import { Pipe, PipeTransform } from '@angular/core';
import { OrderableIngredient, SizePrice } from 'ngx-web-api';

@Pipe({
  name: 'availableSize',
})
export class AvailableSizePipe implements PipeTransform {
  transform(ingredients: OrderableIngredient[], selectedSizePrice: SizePrice): OrderableIngredient[] {
    if (ingredients && selectedSizePrice) {
      return ingredients.filter(ingredient => ingredient.sizePrices.some(ingredientSize => ingredientSize.size === selectedSizePrice.size));
    }
    return ingredients;
  }
}
